import { render, staticRenderFns } from "./textData.vue?vue&type=template&id=289e0546&scoped=true&"
import script from "./textData.vue?vue&type=script&lang=js&"
export * from "./textData.vue?vue&type=script&lang=js&"
import style0 from "./textData.vue?vue&type=style&index=0&id=289e0546&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e0546",
  null
  
)

export default component.exports